import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const SchoolManagement = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="School Management" midBreadcrumb="Office Bearers" mainBreadcrumb="School Management" ></Breadcrumb>
            <div className='inner-page'>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="mainhead">School Management</h2>
                            <div class="auto-container">
                                <div class="row clearfix g-3">
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/president.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Most Rev. Archbishop Anil Couto</a></h3>
                                                <div class="designation">President</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/boy.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">-</a></h3>
                                                <div class="designation">Chairman</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/boy.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. Dr. Sabu Joseph</a></h3>
                                                <div class="designation">Director for Education</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12" >
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/boy.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Rev. Fr. Thavamani</a></h3>
                                                <div class="designation">Asst. Dir. for Education</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Manager-2025.jpg"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Father Ranjit Soreng sfx</a></h3>
                                                <div class="designation">Manager</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/principal-25.jpg"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">-</a></h3>
                                                <div class="designation">Principal</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/mgmt.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Mrs. Nirmala</a></h3>
                                                <div class="designation">Principal, KVS</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/mgmt.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Sr. Juby Joseph</a></h3>
                                                <div class="designation">Head Mistress</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/mgmt.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Mrs. Anita Yadav</a></h3>
                                                <div class="designation">Staff Representative</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/mgmt.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Mrs. Anju Verma</a></h3>
                                                <div class="designation">Staff Representative</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-block col-lg-4 col-md-6 col-sm-12">
                                        <div class="inner-box">
                                            <div class="image">
                                                <a href="#"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/mgmt.png"
                                                    alt="matamariamjansevavidyalayas" class="img-fluid " /></a>
                                            </div>
                                            <div class="lower-content">
                                                <h3><a href="#">Mrs. Dr. Gagan Singhal</a></h3>
                                                <div class="designation">Parent - Member</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default SchoolManagement